import type { IContinueWatchingCardEpisode } from '@setplex/tria-api'

import {
  formatEpisodeInfoLabels,
  formatEpisodeInfoLength,
} from '~/widgets/Popups/InfoPopup/lib/episode'

export type EpisodeInfoPopupSource = IContinueWatchingCardEpisode & {
  formattedSortOrder?: string | null
  episodeDescription?: string | null
  directors?: string | null
  stars?: string | null
  resolution?: string | null
  releaseTimeFormatted?: string | null
  releaseTime?: number | null
  dolbyAtmosAvailable?: boolean | null
}

export const createEpisodeInfoPopupPayload = ({
  contentId,
  contentName,
  episodeItem,
}: {
  contentId?: number
  contentName?: string
  episodeItem: EpisodeInfoPopupSource | null
}) => {
  const lengthFormatted = episodeItem
    ? formatEpisodeInfoLength(episodeItem)
    : null
  const labels = episodeItem ? formatEpisodeInfoLabels(episodeItem) : []

  return {
    condition: true,
    episodeId: contentId ?? null,
    title: episodeItem?.formattedSortOrder ?? episodeItem?.tvShowName ?? null,
    name: contentName ?? null,
    description:
      episodeItem?.episodeDescription ?? episodeItem?.description ?? null,
    directors: episodeItem?.directors ?? null,
    stars: episodeItem?.stars ?? null,
    length: lengthFormatted,
    labels: labels.length > 0 ? labels : null,
    eventDescription: null,
    quality: episodeItem?.resolution ?? null,
    dolbyAtmos: episodeItem?.dolbyAtmosAvailable ?? null,
  }
}
